import { createTextComponent } from './createTextComponent';

export const BodyMicro = createTextComponent({
  styleAs: 'bodyMicro',
  tag: 'div',
});
